import { render, staticRenderFns } from "./RegistrationFormConfirm.vue?vue&type=template&id=0bec1cf3&scoped=true&"
import script from "./RegistrationFormConfirm.vue?vue&type=script&lang=js&"
export * from "./RegistrationFormConfirm.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationFormConfirm.vue?vue&type=style&index=0&id=0bec1cf3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bec1cf3",
  null
  
)

export default component.exports